import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import SuccessScreen from '../../Common/SuccessScreen';

const CompleteDP = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const orderId = location.state?.orderId;
    const filledButtonAction = () => {
        navigate(`/dispatch-plan-detail/${orderId}`)
    }
    const OutlinedButtonAction = () => {
        navigate('/dispatch-status-list');
    }
    return (
        <SuccessScreen
            title="Successful!"
            subtitle={`Your order ${orderId} has been placed.`}
            filledButtonLabel="View Order Details"
            filledButtonAction={filledButtonAction}
            OutlinedButtonLabel="Dispatch Status"
            OutlinedButtonAction={OutlinedButtonAction}
        />
    )
}

export default CompleteDP